<h2 mat-dialog-title>Edit Book Expense</h2>

<div mat-dialog-content>

<mat-form-field appearance="fill" style="width:100%">
<mat-label>Paper Bill</mat-label>
<input matInput type="number" [(ngModel)]="item.paper_bill">
</mat-form-field>

<mat-form-field appearance="fill" style="width:100%">
<mat-label>Printing Bill</mat-label>
<input matInput type="number" [(ngModel)]="item.printing_bill">
</mat-form-field>

<mat-form-field appearance="fill" style="width:100%">
<mat-label>Processing</mat-label>
<input matInput type="number" [(ngModel)]="item.processing">
</mat-form-field>

<mat-form-field appearance="fill" style="width:100%">
<mat-label>Cover</mat-label>
<input matInput type="number" [(ngModel)]="item.cover">
</mat-form-field>

<mat-form-field appearance="fill" style="width:100%">
<mat-label>Other</mat-label>
<input matInput type="number" [(ngModel)]="item.other">
</mat-form-field>

<!-- <mat-form-field appearance="fill" style="width:100%">
<mat-label>Shipping Charges</mat-label>
<input matInput type="number" [(ngModel)]="item.e_shipping_charges">
</mat-form-field> -->

</div>

<div mat-dialog-actions align="end">

<button mat-button (click)="close()">Cancel</button>

<button mat-raised-button color="primary" (click)="saveData()">
Save
</button>

</div>